export default __webpack_public_path__ + "static/media/element_63.2fe30726.jpg";